import { useState, useEffect } from 'react';

//
//
//

const useDelayUnmount = (isMounted, ms_delay = 500) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (isMounted && !shouldRender) {
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = setTimeout(() => setShouldRender(false), ms_delay);
    }

    return () => clearTimeout(timeoutId);
  }, [isMounted, ms_delay, shouldRender]);

  return shouldRender;
};

//
//
//

export default useDelayUnmount;
